<template>
    <button :class="classes" @click="toggle">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1.5 0 26 26" class="h-6">
            <path
                d="M11.672 5.309L12 5.91l.328-.601c.383-.696 1.024-1.641 1.977-2.38.988-.765 2.101-1.148 3.32-1.148 3.398 0 6 2.778 6 6.54 0 2.015-.805 3.726-2.27 5.495-1.476 1.782-3.597 3.59-6.195 5.801l.246.285-.246-.285c-.879.75-1.875 1.602-2.914 2.508a.359.359 0 01-.246.094.359.359 0 01-.246-.094 287.232 287.232 0 00-2.914-2.504l-.246.285.246-.285c-2.598-2.215-4.719-4.023-6.195-5.805-1.465-1.77-2.27-3.48-2.27-5.496 0-3.761 2.602-6.539 6-6.539 1.219 0 2.332.383 3.32 1.149l.227-.297-.227.297c.953.738 1.594 1.683 1.977 2.379zm0 0"
                fill="currentColor"
                stroke="#718096"
                stroke-width="2"
            />
        </svg>
    </button>
</template>

<script>
export default {
    props: {
        slug: { required: true },
        saved: { default: false },
    },

    data() {
        return {
            isSaved: this.saved,
        };
    },
    computed: {
        classes() {
            return [
                'hover:text-gray-600 focus:outline-none z-10',
                this.isSaved
                    ? 'text-gray-600 focus:text-gray-600 active:white'
                    : 'text-white focus:text-white active:text-gray-600',
            ];
        },
    },

    methods: {
        toggle() {
            this.isSaved ? this.remove() : this.save();
        },

        save() {
            axios.post(`/descubre/` + this.slug);

            this.isSaved = !this.isSaved;
        },

        remove() {
            axios.delete(`/descubre/` + this.slug);

            this.isSaved = !this.isSaved;
        },
    },
};
</script>
